import React from 'react';
import { Button } from './ui/Button';
interface HeroSectionProps {
  displayTotal: string;
}
export function HeroSection({
  displayTotal
}: HeroSectionProps) {
  return <section className="relative min-h-[80vh] flex items-center" data-id="element-361">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/wth3XfJLnsMK4hZPUBHWV7/The_Inherited_House_Funnel_page_image_(2).png")'
    }} data-id="element-362" />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 z-10 bg-gradient-to-r from-navy-dark/95 via-navy-dark/80 to-navy-dark/30" data-id="element-363" />
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-navy-dark/90 via-navy-dark/30 to-transparent" data-id="element-364" />

      {/* Content */}
      <div className="relative z-20 w-full max-w-7xl mx-auto px-6 py-20" data-id="element-365">
        <div className="max-w-2xl" data-id="element-366">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 text-shadow-sm" data-id="element-367">
            You Inherited a House. Now What?
          </h1>

          <h3 className="text-xl md:text-2xl text-white font-body font-medium leading-relaxed mb-10 text-shadow-sm" data-id="element-368">
            The step-by-step guide for overwhelmed heirs who need to know
            exactly what to do — without costly mistakes, family conflict, or
            months of confusion.
          </h3>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-369">
            <Button onClick={() => document.getElementById('final-offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-370">
              GET THE SURVIVAL KIT + ALL 4 BONUSES — {displayTotal}
            </Button>
          </div>
        </div>
      </div>
    </section>;
}